import Vue from 'vue'
import Router from 'vue-router'
import HomeContainer from '../components/tabbar/HomeContainer'
import HallContainer from '../components/tabbar/HallContainer'
import UserContainer from '../components/tabbar/UserContainer'
import SecondBuild from '../components/Build/SecondBuild'
import BuildDetail from '../components/Build/BuildDetail'
import FacilitiesDetail from '../components/Build/FacilitiesDetail'
import Login from '../components/user/login'
import integralDetail from '../components/user/integralDetail'
import contributionDetail from '../components/user/contributionDetail'
import group from '../components/user/group'
import lift from '../components/Facilities/lift'
import toilet from '../components/Facilities/toilet'
import ramp from '../components/Facilities/ramp'
import parking from '../components/Facilities/parking'
import seat from '../components/Facilities/seat'
import lowPositionServe from '../components/Facilities/lowPositionServe'
import platform from '../components/Facilities/platform'
import entryExit from '../components/Facilities/entryExit'
import stairLift from '../components/Facilities/stairLift'
import passageway from '../components/Facilities/passageway'
import callhelp from '../components/Facilities/callhelp'
import climbing from '../components/Facilities/climbing'
import guideMap from '../components/Facilities/guideMap'
import register from '../components/user/register'
import smslogin from '../components/user/smslogin'
import overview from "../components/Facilities/overview";
import subwayentry from "../components/Facilities/subwayentry";

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      name: 'HomeContainer',
      redirect:'/home'

    }, {
      path: '/home',
      name: 'HomeContainer',
      component: HomeContainer
    }, {
      path: '/hall',
      name: 'HallContainer',
      component: HallContainer
    }, {
      path: '/user',
      name: 'UserContainer',
      component: UserContainer
    }, {
      path: '/Build/BuildDetail/:taskId/:childId',
      name: 'BuildDetail',
      component: BuildDetail,
      meta: {navShow: false}

    }, {
      path: '/Build/SecondBuild/:taskId',
      name: 'SecondBuild',
      component: SecondBuild,

    }, {
      path: '/Build/FacilitiesDetail/:verifyId',
      name: 'FacilitiesDetail',
      component: FacilitiesDetail,
    }, {
      path: '/user/login',
      name: 'Login',
      component: Login
    }, {
      path: '/user/integral',
      name: 'integralDetail',
      component: integralDetail
    }, {
      path: '/user/contributionDetail',
      name: 'contributionDetail',
      component: contributionDetail
    }, {
      path: '/user/group',
      name: 'group',
      component: group
    }, {
      path: '/facilities/facilities_1/:active/:taskId/:buildingId/:facilitiesTypeId/:id',
      name: 'toilet',
      component: toilet,
      meta: {navShow: false}
    }, {
      path: '/facilities/facilities_3/:active/:taskId/:buildingId/:facilitiesTypeId/:id',
      name: 'seat',
      component: seat
    }, {
      path: '/facilities/facilities_5/:active/:taskId/:buildingId/:facilitiesTypeId/:id',
      name: 'passageway',
      component: passageway

    }, {
      path: '/facilities/facilities_6/:active/:taskId/:buildingId/:facilitiesTypeId/:id',
      name: 'lowPositionServe',
      component: lowPositionServe,
      meta: {navShow: false}

    }, {
      path: '/facilities/facilities_7/:active/:taskId/:buildingId/:facilitiesTypeId/:id',
      name: 'parking',
      component: parking

    }, {
      path: '/facilities/facilities_8/:active/:taskId/:buildingId/:facilitiesTypeId/:id',
      name: 'lift',
      component: lift,
      meta: {navShow: false}

    }, {
      path: '/facilities/facilities_10/:active/:taskId/:buildingId/:facilitiesTypeId/:id',
      name: 'callhelp',
      component: callhelp,
      meta: {navShow: false}

    }, {
      path: '/facilities/facilities_11/:active/:taskId/:buildingId/:facilitiesTypeId/:id',
      name: 'climbing',
      component: climbing,
      meta: {navShow: false}

    }, {
      path: '/facilities/facilities_12/:active/:taskId/:buildingId/:facilitiesTypeId/:id',
      name: 'platform',
      component: platform,
      meta: {navShow: false}

    }, {
      path: '/facilities/facilities_13/:active/:taskId/:buildingId/:facilitiesTypeId/:id',
      name: 'stairLift',
      component: stairLift,
      meta: {navShow: false}
    }, {
      path: '/facilities/facilities_14/:active/:taskId/:buildingId/:facilitiesTypeId/:id',
      name: 'entryExit',
      component: entryExit,
      meta: {navShow: false}

    }, {
      path: '/facilities/facilities_15/:active/:taskId/:buildingId/:facilitiesTypeId/:id',
      name: 'ramp',
      component: ramp,
      meta: {navShow: false}

    }, {
      path: '/facilities/facilities_17/:active/:taskId/:buildingId/:facilitiesTypeId/:id',
      name: 'guideMap',
      component: guideMap

    }, {
      path: '/facilities/facilities_18/:active/:taskId/:buildingId/:facilitiesTypeId/:id',
      name: 'guideMap',
      component: guideMap

    }, {
      path: '/user/register',
      name: 'register',
      component: register
    }, {
      path: '/user/smslogin',
      name: 'smslogin',
      component: smslogin
    }, {
      path: '/facilities/facilities_19/:active/:taskId/:buildingId/:facilitiesTypeId/:id',
      name: 'overview',
      component: overview,
      meta: {navShow: false}

    }, {
      path: '/facilities/facilities_20/:active/:taskId/:buildingId/:facilitiesTypeId/:id',
      name: 'subwayentry',
      component: subwayentry

    }

  ],
  linkActiveClass: 'mui-active'
})



// WEBPACK FOOTER //
// ./src/router/index.js